import { render, staticRenderFns } from "./FollowForm.vue?vue&type=template&id=ed066b5c&scoped=true"
import script from "./FollowForm.vue?vue&type=script&lang=js"
export * from "./FollowForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed066b5c",
  null
  
)

export default component.exports